module.exports = [{
      plugin: require('/Users/colbystauss/Documents/hackDFW/Team-Source/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
